import { UseMutateAsyncFunction, useMutation } from 'react-query';

import { getAPIErrorMessage } from '../../../utils/ApiErrorUtils';

import { LoginWithAuthCodeResponseType } from '../../../services/IbUserAccountsServices/APIService/types';

import { useIbUserAccountsAPIService } from '../useIbUserAccountsAPIService';

function useLoginWithAuthCodeAPI(): {
  loginWithAuthCodeAPI: UseMutateAsyncFunction<
    LoginWithAuthCodeResponseType,
    unknown,
    string,
    unknown
  >;
  error: string;
  status;
} {
  const { ibUserAccountsAPIService } = useIbUserAccountsAPIService();

  const loginWithAuthCode = (authCode: string) => {
    return ibUserAccountsAPIService.loginWithAuthCode(authCode);
  };

  const { mutateAsync, error, status } = useMutation(loginWithAuthCode, {
    mutationKey: ['loginWithAuthCodeAPI']
  });

  return {
    loginWithAuthCodeAPI: mutateAsync,
    error: error ? getAPIErrorMessage(error) : '',
    status
  };
}

export { useLoginWithAuthCodeAPI };
